import styled from 'styled-components';

const Loader = styled.div`
  width: 100%;
  height: 60px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Loader;
